import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { CardBalance, RidangoReduxAction } from '@ridango/core';
import { Observable } from 'rxjs';
import { CardInfoActions } from './card-info.actions';
import { CardInfoPartialStoreState } from './card-info.reducer';
import * as CardInfoSelectors from './card-info.selectors';

@Injectable()
export class CardInfoFacade {
    cardNumber$: Observable<any> = this.store.select(CardInfoSelectors.getCardNumber);
    cardBalance$: Observable<any> = this.store.select(CardInfoSelectors.getBalance);
    cardTickets$: Observable<any> = this.store.select(CardInfoSelectors.getTickets);
    history$: Observable<any> = this.store.select(CardInfoSelectors.getHistory);

    constructor(
        private store: NgRedux<CardInfoPartialStoreState>,
        private actions: CardInfoActions
    ) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    setCardNumber(cardNumber) {
        this.dispatch(this.actions.setCardNumber(cardNumber));
    }

    setCardBalance(cardBalance: CardBalance) {
        this.dispatch(this.actions.setCardBalance(cardBalance));
    }

    setCardTickets(tickets) {
        this.dispatch(this.actions.setCardTickets(tickets));
    }

    setFromDate(date) {
        this.dispatch(this.actions.setFromDate(date));
    }

    setToDate(date) {
        this.dispatch(this.actions.setToDate(date));
    }

    setHistory(history) {
        this.dispatch(this.actions.setHistory(history));
    }

    setLoading(loading) {
        this.dispatch(this.actions.setLoading(loading));
    }
}